<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>商品分类</span>
          <el-button type="primary" size="small" @click="openDialog()">新增分类</el-button>
        </div>
      </template>

      <el-form :inline="true" :model="searchForm" class="search-bar">
        <el-form-item label="分类名称">
          <el-input v-model="searchForm.name" placeholder="请输入" style="width: 200px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="filteredList" stripe size="small" border @row-dblclick="row => openDialog(row)">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="detail-panel dbl-edit" @dblclick="openDialog(props.row)" title="双击任意位置修改">
              <div class="detail-panel-title"><i class="el-icon-info"></i><span>分类详情</span></div>
              <div class="detail-card-row">
                <div class="detail-card-body cols-4">
                  <div class="dc-cell"><span class="dc-label">分类ID</span><span class="dc-value">{{ props.row.id }}</span></div>
                  <div class="dc-cell"><span class="dc-label">分类名称</span><span class="dc-value">{{ props.row.name || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">创建时间</span><span class="dc-value">{{ formatDate(props.row.createTime) }}</span></div>
                  <div class="dc-cell"><span class="dc-label">更新时间</span><span class="dc-value">{{ formatDate(props.row.updateTime) }}</span></div>
                  <div class="dc-cell w4"><span class="dc-label">描述</span><span class="dc-value">{{ props.row.description || '-' }}</span></div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="分类名称" min-width="160"></el-table-column>
        <el-table-column prop="description" label="描述" min-width="240" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" width="170">
          <template slot-scope="s">{{ formatDate(s.row.createTime) }}</template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="s">
            <el-button size="mini" type="primary" @click="openDialog(s.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(s.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="form.id ? '修改分类' : '新增分类'" :visible.sync="dialogVisible" width="880px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="90px" size="small">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="form.description" type="textarea" :rows="3" placeholder="可选"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="success" @click="handleSubmit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { categoryApi } from '../api/api'

export default {
  name: 'Category',
  data() {
    return {
      categoryList: [],
      searchForm: { name: '' },
      dialogVisible: false,
      form: this.emptyForm(),
      rules: { name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }] }
    }
  },
  computed: {
    filteredList() {
      const k = (this.searchForm.name || '').trim().toLowerCase()
      if (!k) return this.categoryList
      return this.categoryList.filter(c => (c.name || '').toLowerCase().includes(k))
    }
  },
  mounted() { this.loadList() },
  methods: {
    emptyForm() { return { id: null, name: '', description: '' } },
    loadList() {
      categoryApi.getCategoryList().then(res => { this.categoryList = res.data || [] })
    },
    handleSearch() { /* 客户端过滤，无需重拉 */ },
    resetSearch() { this.searchForm = { name: '' } },
    openDialog(row) {
      this.form = row ? { ...row } : this.emptyForm()
      this.dialogVisible = true
      this.$nextTick(() => { if (this.$refs.form) this.$refs.form.clearValidate() })
    },
    handleDelete(id) {
      this.$confirm('确定删除该分类？', '提示', { type: 'warning' }).then(() => {
        categoryApi.deleteCategory(id).then(res => {
          if (res.data) { this.$message.success('删除成功'); this.loadList() }
        })
      }).catch(() => {})
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const api = this.form.id ? categoryApi.updateCategory(this.form) : categoryApi.addCategory(this.form)
        api.then(res => {
          if (res.data) {
            this.$message.success(this.form.id ? '修改成功' : '新增成功')
            this.dialogVisible = false
            this.loadList()
          } else {
            this.$message.error('操作失败')
          }
        })
      })
    },
    formatDate(v) { return v ? String(v).replace('T', ' ').slice(0, 10) : '-' }
  }
}
</script>

<style scoped>
.card-header { display: flex; align-items: center; justify-content: space-between; }
.search-bar { margin-bottom: 16px; }

.detail-panel { padding: 14px 24px 18px; background: linear-gradient(180deg,#fafcff 0%,#f5f7fa 100%); border-top: 1px dashed #dcdfe6; }
.detail-panel-title { display: flex; align-items: center; gap: 6px; color: #303133; font-size: 13px; font-weight: 600; margin: 4px 0 12px; }
.detail-panel-title i { color: #409eff; }
.detail-card-row { background: #fff; border: 1px solid #ebeef5; border-radius: 6px; box-shadow: 0 1px 2px rgba(0,0,0,0.02); padding: 12px 14px; margin-bottom: 12px; }
.detail-card-body { display: grid; gap: 8px; }
.detail-card-body.cols-4 { grid-template-columns: repeat(4, 1fr); }
.dc-cell { display: flex; justify-content: flex-start; align-items: center; gap: 8px; padding: 6px 10px; background: #f8f9fb; border-radius: 4px; }
.dc-cell.w4 { grid-column: span 4; }
.dc-label { color: #909399; font-size: 12px; flex-shrink: 0; }
.dc-label::after { content: '：'; }
.dc-value { color: #303133; font-size: 13px; font-weight: 500; }
.dbl-edit { cursor: pointer; transition: background .15s; }
.dbl-edit:hover { background: #f0f7ff; }
</style>
